"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickNumberRange = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
function PickNumberRange(props) {
    const { onSelect, suffix, minValue, maxValue, float = false, queryField, onCancel } = props;
    const [fromStr, setFromStr] = (0, react_1.useState)(minValue ? minValue.toString() : '');
    const [toStr, setToStr] = (0, react_1.useState)(maxValue ? maxValue.toString() : '');
    const inputProps = (0, react_1.useMemo)(() => ({
        style: { width: 80 },
    }), []);
    const InputProps = (0, react_1.useMemo)(() => ({
        style: {
            width: 90,
            padding: '4px !important',
        },
        endAdornment: suffix ? (react_1.default.createElement(Text_1.default, { variant: "small", color: "lightgrey" }, suffix)) : undefined,
    }), [suffix]);
    const handleChangeValues = (0, react_1.useCallback)(() => {
        const hasMin = minValue !== undefined;
        const hasMax = maxValue !== undefined;
        let from;
        let to;
        try {
            from = float ? parseFloat(fromStr) : parseInt(fromStr);
            to = float ? parseFloat(toStr) : parseInt(toStr);
        }
        catch (e) {
            return;
        }
        if (hasMax && to > maxValue)
            to = maxValue;
        if (hasMin && to < minValue + 1)
            to = minValue + 1;
        if (hasMax && from > maxValue - 1)
            from = maxValue - 1;
        if (hasMin && from < minValue)
            from = minValue;
        if (from >= to) {
            to = from + 1;
        }
        setFromStr(from + '');
        setToStr(to + '');
        return { from, to };
    }, [fromStr, maxValue, minValue, toStr, float]);
    const handleClickCancel = (0, react_1.useCallback)(() => {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }, [onCancel]);
    const handleClickOk = (0, react_1.useCallback)(() => {
        const { from, to } = handleChangeValues();
        const title = from + suffix + ' - ' + to + suffix;
        onSelect({ queryFieldKey: queryField.key, id: from + '_' + to, title, from, to });
    }, [handleChangeValues, suffix, onSelect, queryField]);
    return (react_1.default.createElement(Vertical_1.default, { padding: true, gutter: true },
        react_1.default.createElement(Horizontal_1.default, { gutter: true },
            react_1.default.createElement(TextField_1.default, { value: fromStr, onChange: setFromStr, onBlur: handleChangeValues, label: "From:", type: "number", InputProps: InputProps, inputProps: inputProps }),
            react_1.default.createElement(TextField_1.default, { value: toStr, onChange: setToStr, onBlur: handleChangeValues, label: "To:", type: "number", InputProps: InputProps, inputProps: inputProps })),
        react_1.default.createElement(Horizontal_1.default, { gutter: true },
            react_1.default.createElement(Button_1.default, { onClick: handleClickCancel, color: lib_palette_1.default.LavendarGrey, label: 'Cancel' }),
            react_1.default.createElement(Button_1.default, { onClick: handleClickOk, color: lib_palette_1.default.positive, label: 'Ok' }))));
}
exports.PickNumberRange = PickNumberRange;
exports.default = PickNumberRange;
